import { useEffect, useRef, useState } from "react";
import AISC from '../../assets/aisc.png';
import NISD from '../../assets/nisd.png';
import SDS from '../../assets/sds2_certification-badge__Detailer.png';

const STATS = [
    { value: 32, suffix: '+', label: 'Years in Business', sub: 'Since 1993' },
    { value: 500, suffix: '+', label: 'Projects Delivered', sub: 'Commercial · Industrial · Public Works' },
    { value: 100, suffix: '%', label: 'SDS2 Modeled', sub: 'Every drawing, every detail' },
];

const useCountUp = (target, duration = 1400) => {
    const [value, setValue] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const start = performance.now();
                    const step = (now) => {
                        const progress = Math.min((now - start) / duration, 1);
                        const eased = 1 - Math.pow(1 - progress, 3);
                        setValue(Math.round(target * eased));
                        if (progress < 1) requestAnimationFrame(step);
                    };
                    requestAnimationFrame(step);
                }
            });
        }, { threshold: 0.4 });
        observer.observe(node);
        return () => observer.disconnect();
    }, [target, duration]);

    return [ref, value];
};

const Stat = ({ value, suffix, label, sub }) => {
    const [ref, current] = useCountUp(value);
    return (
        <div ref={ref} className="text-center md:text-left">
            <div className="font-display text-5xl md:text-6xl font-bold text-navy-900 tabular-nums">
                {current}<span className="text-accent">{suffix}</span>
            </div>
            <div className="mt-2 text-sm font-semibold text-navy-700 uppercase tracking-wider">{label}</div>
            <div className="text-sm text-steel-500 mt-1">{sub}</div>
        </div>
    );
};

export const TrustBar = () => (
    <section className="bg-white py-16 md:py-24 border-b border-steel-100">
        <div className="container-px mx-auto max-w-7xl">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mb-16">
                {STATS.map((s) => <Stat key={s.label} {...s} />)}
            </div>

            <div className="pt-12 border-t border-steel-100">
                <p className="text-center text-xs font-semibold text-steel-500 uppercase tracking-[0.2em] mb-8">
                    Memberships & Certifications
                </p>
                <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8">
                    <img src={AISC} alt="AISC Member" className="h-16 md:h-20 object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all" />
                    <img src={NISD} alt="NISD Member" className="h-16 md:h-20 object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all" />
                    <img src={SDS} alt="SDS2 Certified Detailer" className="h-16 md:h-20 object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all" />
                </div>
            </div>
        </div>
    </section>
);
